export default {
  name: 'zh-cn',
  epx: {
    common: {
      sure: '确定',
      cancel: '取消',
      selectPlaceholder: '请选择或搜索',
      noData: '暂无数据',
    },
    tablePage: {
      totalPageSize: '共 {totalPageSize} 页',
      total: '共 {total} 条记录',
    },
    tableDialog: {
      selectedField: '已选字段',
    },
    collapse: {
      openText: '展开',
      closeText: '收起',
    },
    case: {
      title: '中文标题',
    },
    editor: {
      link: '链接',
      linkPlaceholder: '黏贴或输入一个链接',
      target: '新窗口打开',
      add: '添加',
      uploadPicture: '上传图片',
      onlinePicture: '网络图片',
      pictureAddress: '图片地址',
      pictureDescription: '图片描述',
      insert: '插入',
      uploadVideo: '上传视频',
      onlineVideo: '网络视频',
      videoAddress: '视频地址',
      videoWidth: '视频宽度',
      small: '小',
      middel: '中',
      large: '大',
      boldTip: '加粗',
      italicTip: '斜体',
      bulletTip: '无序列表',
      orderedTip: '有序列表',
      blockquoteTip: '引用',
      codeTip: '代码块',
      strikeTip: '删除线',
      undoTip: '撤销',
      redoTip: '重做',
      emojiTip: '表情',
      underlineTip: '下划线',
      horizontalTip: '分割线',
      alignLeftTip: '左对齐',
      alignRightTip: '右对齐',
      alignCenterTip: '居中对齐',
      alignJustifyTip: '两端对齐',
      imageTip: '图片',
      videoTip: '视频',
      linkTip: '链接',
      headingTip: '标题大小',
      fontSizeTip: '字体大小',
    },
    virtualList: {
      loadingText: '加载中...',
      errorText: '请求失败，点击重新加载',
      finishedText: '没有更多了',
    },
    emoji: {
      weixinEmoji: '微信表情',
      commonEmoji: '通用表情',
    },
    loadMore: {
      moreText: '滚动加载',
      loadingText: '加载中...',
      errorText: '请求失败，点击重新加载',
      noMoreText: '没有更多了',
    },
    tabsSelect: {
      searchPlaceholder: '请输入关键词以搜索',
      loading: '加载中...',
      searchEmptyText: '暂无搜索结果',
    },
  },
}
